import React from 'react'
import { graphql } from 'gatsby'
import Image from 'gatsby-image'
import styled, { css } from 'react-emotion'
import Layout from '../components/layout'
import OutlineBox from '../components/outline-box'
import colors from '../constants/colors'
import { fontSize } from '../utils/css'

const centerBio = css`
  display: inline-block;
  position: fixed;
  line-height: 1em;
  color: ${colors.darkGray};
  ${fontSize(2, 4, 400, 800)};
  top: 38%;
  right: 20px;
  filter: blur(1px);

  @media (min-width: 450px) {
    top: 30%;
    left: 10%;
  }
`

const Bio = styled.div`
  position: relative;
  display: inline-block;
  color: black;
  ${fontSize(1, 0.8, 400, 800)};
  top: 50%;
  margin-left: 10px;
  
  p {
    margin: 0;
    line-height: 3rem;
  }

  a {
    display: inline-block;
    border-bottom: 2px dashed ${colors.outline};
    line-height: 3rem;

    &:hover {
      background: ${colors.seafoam};
      color: black;
      border-bottom: 2px solid white;
    }
  }

  span {
    background: rgba(255,255,255,0.8);
  }


  @media (min-width: 450px) {
    padding: 30px;
    line-height: 4.5em;
    background: rgba(255,255,255,0.4);

    a {
      line-height: 4em;
    }
  }
`

const ImgOverlay = styled.div`
  position: absolute;
  max-height: 40vh;
  width: 100%;
  bottom: 0;
  opacity: 0.99;

  @media (min-width: 800px) {
    width: 70%;
    max-width: 800px;
    left: 30%;
    top: 40%;
    bottom: unset;
  }

  &::after {
    content: "";
    background: linear-gradient(
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.9) 50%,
      rgba(255, 255, 255, 0)
    );
    top: 0;
    width: calc(100% + 2px);
    left: -1px;
    max-height: 40vh;
    height: 100%;
    position: absolute;
  }
`

const AboutPage = ({
	data: {
		prismicAbout: { data }
	}
}) => (
	<Layout>
		<ImgOverlay>
			<Image fluid={data.image.localFile.childImageSharp.fluid} />
		</ImgOverlay>
		<OutlineBox className={centerBio}>
			<span>{data.headline.text}</span>
		</OutlineBox>
		<Bio dangerouslySetInnerHTML={{ __html: data.description.html }} />
	</Layout>
)

export default AboutPage

export const query = graphql`
  query aboutPage {
    prismicAbout {
      data {
        headline {
          text
        }

        description {
          html
        }

        image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 700) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
